import { create } from 'zustand';
import i18next from 'i18next';
import zh from './locales/zh';
import en from './locales/en';

export type SupportedLanguage = 'zh' | 'en';

type Dictionaries = {
  zh: typeof zh;
  en: typeof en;
};

const dictionaries: Dictionaries = { zh, en };

function detectInitialLang(): SupportedLanguage {
  const stored = localStorage.getItem('app_lang');
  if (stored === 'zh' || stored === 'en') return stored;
  const n = navigator?.language?.toLowerCase?.() || 'en';
  if (n.startsWith('zh')) return 'zh';
  return 'en'; // 默认英文
}

interface I18nState {
  lang: SupportedLanguage;
  t: (key: string, options?: Record<string, unknown>) => string;
  switchTo: (lang: SupportedLanguage) => void;
}

// Initialize i18next once
const initialLang = detectInitialLang();
i18next.init({
  lng: initialLang,
  fallbackLng: 'en',
  resources: {
    zh: { translation: zh },
    en: { translation: en },
  },
  interpolation: { escapeValue: false },
});

export const useI18n = create<I18nState>((set) => ({
  lang: initialLang,
  t: (key, options) => i18next.t(key as any, options as any) as string,
  switchTo: (lang) => {
    localStorage.setItem('app_lang', lang);
    i18next.changeLanguage(lang);
    set({ lang });
  },
}));

export function getCurrentDictionary() {
  const { lang } = useI18n.getState();
  return dictionaries[lang];
}


